<!-- SUB BANNER -->
<section class="section-sub-banner awe-parallax bg-16">

  <div class="awe-overlay"></div>

  <div class="sub-banner">
    <div class="container">
      <div class="text text-center">
        <h2>ADMIN ACCESS</h2>
        <p></p>
      </div>
    </div>

  </div>

</section>
<!-- END / SUB BANNER -->

<div class="container">
  <div class="row">
    <div class="col-md-12">
      <section class="section-reservation-page bg-white">

        <div class="container">
          <div class="reservation-page">

            <div class="row">
              <!-- EXPORT TO EXCEL -->
              <div class="col-sm-12">
                <button kendoButton type="button" [icon]="'excel'" class="btn btn-info" (click)="excelexport.save()">
                  Export Registration List To Excel</button>
                <kendo-excelexport [data]="allBookings$ | async" fileName="Empowered21Registrations.xlsx" #excelexport>
                  <kendo-excelexport-column field="groupId" title="Group Id" [width]="300">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="bookingDate" title="Booking Date" [width]="250">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="title" [locked]="true" title="Title" [width]="100">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="firstNames" title="First Names" [width]="300">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="lastName" title="LastName" [width]="200">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="email" title="Email Address" [width]="200">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="gender" title="Gender" [width]="100">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="country" title="Country" [width]="150">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="idNumber" title="ID Number/Passport" [width]="150">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="mobilePhone" title="Mobile Number" [width]="150">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="nameOfChurch" title="Church" [width]="200">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="groupASession" title="Track A Session" [width]="400">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="groupBSession" title="Track B Session" [width]="400">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="arrivalDate" title="Arrival Date" [width]="200">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="departureDate" title="Departure Date" [width]="200">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="meal1" title="Day 1 Meal" [width]="200">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="meal2" title="Day 2 Meal" [width]="200">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="meal3" title="Day 3 Meal" [width]="200">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="packageChoice" title="Accommodation Package" [width]="200">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="hotelChoice1" title="Hotel Choice 1" [width]="200">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="hotelChoice2" title="Hotel Choice 2" [width]="200">
                  </kendo-excelexport-column>
                  <kendo-excelexport-column field="hotelChoice3" title="Hotel Choice 3" [width]="200">
                  </kendo-excelexport-column>
                  <!-- <kendo-excelexport-column field="Discontinued" width="120" [hidden]="true">
                    <ng-template kendoExcelExportGroupHeaderTemplate let-value="value">
                      Discontinued: {{value}}
                    </ng-template>
                  </kendo-excelexport-column> -->
                </kendo-excelexport>
              </div>

              <hr>

              <div class="row">
                <!-- <app-top-panel></app-top-panel> -->
                <app-bottom-panel></app-bottom-panel>
              </div>

              <!-- <div class="col-sm-12">

                <div class="table-responsive">

                  <kendo-grid [data]="gridView" class="table table-responsive" height="400" [pageSize]="pageSize" [skip]="skip" [pageable]="true"
                    (pageChange)="pageChange($event)" [sortable]="true">
                    [height]="510">
                    <kendo-grid-column title="Full Name">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.firstNames}} {{dataItem.lastName}}
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="gender" title="Gender"></kendo-grid-column>
                    <kendo-grid-column field="country" title="Country"></kendo-grid-column>
                    <kendo-grid-column field="nameOfChurch" title="Church"></kendo-grid-column>
                  </kendo-grid>

              
                </div>
              </div> -->

            </div>
          </div>
        </div>

      </section>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/admin/admin.component.html